import React from 'react'
import SomethingWentWrongImg from '../../assets/images/Something_went_wrong.svg'
import Button from '../buttons/Button'
import { useSelector } from 'react-redux';
import { useGenerateImages } from '../../services/imageService';

const SomethingWentWrongError = () => {
    const generateImages = useGenerateImages();

    const { lastPayload } = useSelector((state) => state.createImage);

    const handleTryAgainButton = () => {
        if (lastPayload) {
            generateImages(
                lastPayload.prompt_id,
                lastPayload.user_prompt,
                {
                    md5: lastPayload.font_id,
                    font_name: lastPayload.fontName,
                    family_url: lastPayload.fontFamilyUrl,
                    foundry_name: lastPayload.foundryName,
                },
            );
        }
    }

    return (
        <div className='h-[calc(100vh-80px)] w-full'>
            <div className='h-full flexCenter flex-col gap-[48px]'>
                <img src={SomethingWentWrongImg} alt="server busy" className='h-[35%] w-[35%] xl:h-[275px] xl:w-[328px]' />
                <div className='h-[208px] max-w-[876px]  text-center flexCenter flex-col gap-[24px]'>
                    <h1 className='text-[#313945] font-helveticaDisp-Bold text-[40px] font-[700] leading-[48px] tracking-[-0.02em]'>Uh-oh! Something went wrong.</h1>
                    <p className='text-[23px] text-secondary'>We're on it—let's see what we can do to fix this and get you that awesome result, feel free to go back or try again.</p>
                    <Button onClick={handleTryAgainButton} label='Try again' className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[48px] " />
                </div>

            </div>
        </div>
    )
}

export default SomethingWentWrongError